import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import showStripeIcon from "./show-stripe.svg";
import styles from "./style.module.less";

export interface StripeTableRow {
  id: string;
  stripe: string;
}

export interface StripeTableProps {
  rows: readonly StripeTableRow[];
  onShowStripe?: (id: string) => void;
  accentColorIndex?: number | null;
  accentColor?: string;
  stripeColumnLabel?: string;
  className?: string;
}

const StripeTable: FC<StripeTableProps> = ({
  rows,
  onShowStripe,
  accentColorIndex = 1,
  accentColor,
  stripeColumnLabel,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <table className={`${styles.table} ${className ?? ""}`}>
      <thead>
        <tr>
          <th scope="col">
            {stripeColumnLabel ??
              formatTranslation(t("newRatesAndDosage.stripeTable.strips"))}
          </th>
          <th scope="col" className={styles.showColumn}>
            <span className={styles.srOnly}>
              {formatTranslation(t("newRatesAndDosage.stripeTable.show"))}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <th scope="row">
              <span
                className={`${styles.accent} ${
                  accentColorIndex == null
                    ? ""
                    : styles[`accent${accentColorIndex}`] ?? ""
                }`}
                style={{ backgroundColor: accentColor }}
                aria-hidden="true"
              />
              <span className={styles.stripeLabel}>{row.stripe}</span>
            </th>
            <td className={styles.showColumn}>
              <button
                type="button"
                className={styles.showButton}
                aria-label={formatTranslation(
                  t("newRatesAndDosage.stripeTable.showStripe", {
                    stripe: row.stripe,
                  })
                )}
                onClick={() => onShowStripe?.(row.id)}
              >
                <img src={showStripeIcon} alt="" aria-hidden="true" />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default StripeTable;
